// apps/web/src/pages/AdminMembers.tsx
import AdminMemberList from '../components/AdminMemberList';
import { useAllMembers } from '../lib/members';
import { useAllBoatPlaces } from '../lib/boats';
import { useEffect, useState } from 'react';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db } from '../firebase';
import type { Boat } from '../lib/boats';

function useAllBoats(): { boats: (Boat & { id: string })[]; loading: boolean } {
  const [boats, setBoats] = useState<(Boat & { id: string })[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const q = query(collection(db, 'boats'));
    return onSnapshot(q, (snap) => {
      setBoats(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Boat) })));
      setLoading(false);
    });
  }, []);
  return { boats, loading };
}

export default function AdminMembers() {
  const { members, loading: lm } = useAllMembers();
  const { places, loading: lp } = useAllBoatPlaces();
  const { boats, loading: lb } = useAllBoats();
  if (lm || lp || lb) return <p>Laddar…</p>;
  return <AdminMemberList members={members} boats={boats} places={places} />;
}
